export function isSetter(value) {
    return typeof value === 'function';
}
